import { type DatiSessioneUtente } from '@framework/api-client/api/users/schemas/datiSessioneUtente.ts';
import { type PermissionType } from './PermissionType.ts';

/**
 * Gestisce la logica di controllo dei permessi.
 */
export class PermissionLogic {
  /**
   * Controlla se il ruolo dell'utente da accesso al permesso richiesto.
   * In caso di più permessi,  controlla se il ruolo dell'utente
   * dà accesso ad **ALMENO UNO** dei permessi richiesti
   */
  static has(
    user: DatiSessioneUtente | null | undefined,
    permission: PermissionType | PermissionType[],
  ) {
    if (!user) return false;
    const allPermissions = Array.isArray(permission)
      ? permission
      : [permission];

    return allPermissions.some(perm =>
      user.utenteLoggato?.utenteUfficis?.some(u =>
        u.ruolos?.some(r =>
          r.idAbilitazioni.some(id => (id as PermissionType) === perm),
        ),
      ),
    );
  }

  static getSelectedOfficeAndRole(user: DatiSessioneUtente | null | undefined) {
    if (
      !(
        user &&
        user.utenteLoggato?.utenteUfficis?.length === 1 &&
        user.utenteLoggato?.utenteUfficis?.[0]?.ruolos?.length === 1
      )
    )
      return { officeId: null, roleId: null };

    const office = user.utenteLoggato?.utenteUfficis?.[0];
    const role = office?.ruolos?.[0];
    return { officeId: office?.idUfficio, roleId: role?.id };
  }

  static hasBackofficePermission(user?: DatiSessioneUtente | null) {
    return (
      user?.utenteLoggato?.utenteUfficis?.some(({ ruolos }) =>
        ruolos?.some(({ flagBackoffice }) => flagBackoffice),
      ) ?? false
    );
  }

  static hasAdminPermission(user?: DatiSessioneUtente | null) {
    return (
      user?.utenteLoggato?.utenteUfficis?.some(({ ruolos }) =>
        ruolos?.some(({ flagConfiguratore }) => flagConfiguratore),
      ) ?? false
    );
  }
}
